import {
  DRIVER_EVENTS,
  Drop_Hook_Move_Page_Names,
} from "../constants";

const isTrailerDropFieldVisible = (field, dropType, data = {}) => {
  switch (field) {
    case "customer":
      return !["TemporaryLocation", "AgentOrInterline"].includes(dropType);
    case "customerName":
      return (
        data.customer === "other" &&
        !["TemporaryLocation", "AgentOrInterline"].includes(dropType)
      );
    case "agentDetail":
      return dropType === "AgentOrInterline";
    case "locationName":
      return dropType === "TemporaryLocation";

    default:
      return false;
  }
};

const canAddTrailer = (
  attachedTrailersCount,
  hookedTrailersCount,
  maxAllowedTrailerCount
) => {
  return (
    attachedTrailersCount >= maxAllowedTrailerCount ||
    attachedTrailersCount + hookedTrailersCount >= maxAllowedTrailerCount
  );
};

const getArrivedAtStopId = (routeData) => {
  return routeData.currentStatus?.status === DRIVER_EVENTS.ArrivedAtStop
    ? routeData.currentStatus?.stopId
    : null;
};

const getPageDetails = (pageName) => {
  return {
    isDropHookPage: pageName === Drop_Hook_Move_Page_Names.DROP_HOOK_MOVE,
    isTrailerDropFormPage: pageName === Drop_Hook_Move_Page_Names.TRAILER_DROP,
    isSelectShipmentPage: pageName === Drop_Hook_Move_Page_Names.MOVE_BILLS,
  };
};

export {
  isTrailerDropFieldVisible,
  canAddTrailer,
  getArrivedAtStopId,
  getPageDetails,
};
